import React from 'react';
import './Error.sass';

function Error() {
	return (
		<svg
			width="20px"
			height="20px"
			viewBox="0 0 20 20"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g fill="#E31837">
					<g>
						<path d="M10,2.756 L17.862,18.48 L2.138,18.48 L10,2.756 Z M10,0.52 L0.52,19.48 L19.48,19.48 L10,0.52 L10,0.52 Z" />
						<path d="M9.961,15.571 C9.603,15.571 9.34,15.845 9.34,16.224 C9.34,16.592 9.592,16.876 9.961,16.876 C10.34,16.876 10.582,16.592 10.582,16.224 C10.582,15.845 10.34,15.571 9.961,15.571" />
						<polyline points="10.319 14.718 10.466 9.665 9.456 9.665 9.603 14.718 10.319 14.718" />
					</g>
				</g>
			</g>
		</svg>
	);
}

export default Error;
